import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {ControleAcessoService} from '../../client/sgsia/controle-acesso/controle-acesso.service';
import {ControleAcessoFiltroSgsia} from '../../model/sgsia/controle-acesso-filtro-sgsia';
import {SegurancaService} from '../../service/seguranca.service';

@Injectable({providedIn: 'root'})
export class RestringirAcessoGuard implements CanActivate, CanActivateChild {

    private whitelist = [
        '/gestao-acesso/solicitar-acesso',
        '/gestao-acesso/consultar',
        '/gestao-acesso/visualizar',
        '/gestao-acesso/editar'];

    private validado = false;
    private temPermissao = false;

    constructor(private router: Router,
                private controleAcessoService: ControleAcessoService,
                private segurancaService: SegurancaService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        const url = state.url.split('?')[0];
        const noUserLogged = !this.segurancaService.getUsuarioLogado();

        if (noUserLogged || !this.segurancaService.isAnalistaFiscal() || this.whitelist.some(publicUrl => url.startsWith(publicUrl))) {
            return true;
        }

        if (this.validado) {
            return this.temPermissao ? true : this.router.parseUrl('/gestao-acesso/solicitar-acesso');
        } else {

            return new Observable(observer => {
                    const filtro: ControleAcessoFiltroSgsia = new ControleAcessoFiltroSgsia();
                    filtro.idPessoaFiscal = this.segurancaService.getUsuarioLogado().idPessoa;
                    filtro.situacao = 'APROVADO';
                    filtro.ativo = true;

                    this.controleAcessoService.consultar(filtro).subscribe(data => {
                        this.validado = true;

                        if (!!data.conteudo && data.conteudo.length > 0) {
                            this.temPermissao = true;
                            observer.next(true);
                        } else {
                            this.temPermissao = false;
                            observer.next(this.router.parseUrl('/gestao-acesso/solicitar-acesso'));
                        }
                        observer.complete();
                    }, result => {
                        console.log(result);
                        observer.next(this.router.parseUrl('/gestao-acesso/solicitar-acesso'));
                        observer.complete();
                    });
                }
            );

        }
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.canActivate(childRoute, state);
    }

}
